/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-08-05 14:19:56
 * @LastEditors: voanit
 * @LastEditTime: 2021-09-09 10:26:50
 */
import { dataCheck } from '@/utils'
import { phoneVerification, emailVerification } from '@/utils/verification'
const that = window.eventBus

const validPhone = (rule, value, callback) => {
  if (!value) {
    callback(new Error(that.$t('system::rbac::phone_tips')))
  } else if (phoneVerification(value) || emailVerification(value)) {
    callback()
  } else {
    callback(new Error($t('system::rbac::phone_tips_wrong')))
  }
}

export const columns = [
  {
    label: that.$t('system::rbac::user_name'),
    prop: 'name',
    minWidth: 200,
    formatter: row => dataCheck(row.name)
  },
  {
    label: that.$t('system::rbac::phone_num'),
    prop: 'account',
    minWidth: 150,
    formatter: row => dataCheck(row.account)
  },
  {
    label: that.$t('system::rbac::shop'),
    prop: 'shopName',
    minWidth: 250,
    formatter: row => {
      const temp = (row.authorizeDatas || []).map(item => item.dataName)
      return temp.join('，')
    }
  },
  {
    label: that.$t('system::rbac::opt'),
    prop: 'operate',
    width: 180
  }
]
export const columnsTeam = [
  {
    label: that.$t('system::team::user_name'),
    prop: 'loginName',
    minWidth: 200,
    formatter: row => dataCheck(row.loginName)
  },
  {
    label: that.$t('system::team::account'),
    prop: 'accountNumber',
    minWidth: 150,
    formatter: row => dataCheck(row.accountNumber)
  },
  {
    label: that.$t('system::team::team'),
    prop: 'team',
    minWidth: 220,
    formatter: row => {
      return dataCheck(row.team)
    }
  },
  {
    label: that.$t('system::team::role'),
    prop: 'roleList',
    minWidth: 150,
    formatter: row => {
      return dataCheck((row.roleList|| []).map(item=>item.roleName).join(','))
    }
  },
  {
    label: that.$t('system::team::ctl'),
    prop: 'operate',
    width: 180
  }
]

export const rules = {
  name: [{ required: true, message: that.$t('system::rbac::name_input'), trigger: 'blur' }],
  account: [{ required: true, validator: validPhone, trigger: 'blur' }],
  authorizeDataIds: [{ type: 'array', required: true, message: that.$t('system::rbac::auth_shop_input'), trigger: 'change' }]
}
